import Contact from "./pages/Contact";
// import Guidance from "./pages/Guidance";
// import Address from "./pages/Address";
import Login from "./pages/Login";
// import Comment from "./pages/Comment"

const routes = [
 

  // {
  //   path: 'address',
  //   name: "ثبت آدرس محل سکونت",
  //   icon: "fa fa-map-marker-alt",
  //   component: Address,
  //   layout: "menu",
  // },
  {
    path: 'contact',
    name: "ارتباط با پشتیبانی",
    icon: "far fa-message",
    component: Contact,
    layout: "menu",
  },
  
  // {
  //   path: 'comment',
  //   name: "ثبت نظرات و پیشنهادات",
  //   icon: "far fa-file-alt",
  //   component: Comment,
  //   layout: "menu",
  // },


  // {
  //   path: 'guidance',
  //   name: "راهنما",
  //   icon: "far fa-lightbulb",
  //   component: Guidance,
  //   layout: "menu",
  // },

];

export default routes;
